module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point3_2-e57fcb40a88fd7142702a59f3e5af443.jpg";